// extracted by mini-css-extract-plugin
export default {"deviceTypes":"DeviceTypes_deviceTypes__MpbwD"};